import axios from 'axios';
const plainAxios = axios.create();
export const makeVRMClient = ({ httpProvider, makeUrl, setToken, deleteToken }) => {
    return {
        httpProvider,
        session: {
            setToken,
            deleteToken
        },
        validateReferenceFrame: async (sessionKey, frame) => {
            const awsS3Link = await httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/reference/image/upload`));
            const headers = { 'Content-Type': 'image/jpeg' };
            await plainAxios.put(awsS3Link.data.uploadLink.uri, frame, { headers });
            return httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/reference/image/validate`));
        },
        validateReferenceVideoOnVRM: async (sessionKey, video) => {
            const awsS3Link = await httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/reference/video/upload`));
            const headers = { 'Content-Type': 'video/mp4' };
            await plainAxios.put(awsS3Link.data.uploadLink.uri, video, { headers });
            return httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/reference/video/validate`));
        },
        endProctoringSession: (sessionKey) => httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}`)),
        getMobileCameraFrameDownloadUrl: async (sessionKey, proctoringType) => {
            return httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/images/preview/download`), {
                proctoringType
            });
        },
        uploadMobileCameraFrame: async (uploadUrl, data) => {
            const headers = { 'Content-Type': 'image/jpeg' };
            return plainAxios.put(uploadUrl, data, { headers });
        },
        deleteMobileCameraFrames: async (sessionKey, proctoringType) => {
            return httpProvider.delete(makeUrl(`/api/v2/proctoring/${sessionKey}/images/preview`), {
                data: {
                    proctoringType
                }
            });
        },
        getMobileCameraFrameUploadUrl: async (sessionKey, proctoringType, recordedAt) => {
            const awsS3Link = await httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/images/preview/upload`), {
                recordedAt,
                proctoringType
            });
            return awsS3Link.data.uploadLink;
        },
        uploadProctoringChunkToVRM: async (sessionKey, proctoringType, chunkId, data, recordedAt, fileFormat = 'MP4', contentType = 'video/mp4') => {
            const awsS3Link = await httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/videos/chunks/${chunkId}/upload`), {
                recordedAt,
                proctoringType,
                fileFormat
            });
            const headers = { 'Content-Type': contentType };
            return plainAxios.put(awsS3Link.data.uploadLink.uri, data, { headers });
        },
        sendTimestampToVRM: async (sessionKey, value, type, recordedAt) => {
            return httpProvider.post(makeUrl(`/api/v2/proctoring/${sessionKey}/timestamps`), {
                recordedAt,
                type,
                value
            });
        },
        getServerTime: async (localTimestamp) => {
            return httpProvider.get(makeUrl(`/api/v2/timestamp/${localTimestamp}`));
        }
    };
};
//# sourceMappingURL=client.js.map